import { pictureOptions, type PictureChoices } from "@studio/shared";

/**
 * 그림 수업(2026-09-24) 화면용 도우미.
 *
 * 🔑 프롬프트는 여기서 만들지 않는다 — 서버가 칸 키로 조립한다(`server/src/lib/picture-prompt.ts`).
 *    이 파일이 만드는 것은 학생·교사가 읽는 **요약 한 줄**뿐이다.
 */

type Group = keyof typeof pictureOptions;

function optionOf<G extends Group>(group: G, key: string | undefined) {
  if (!key) return null;
  return (pictureOptions[group] as readonly { key: string; label: string; emoji?: string }[])
    .find((option) => option.key === key) ?? null;
}

/** 「👦 남자아이 · 짧은 머리 · 😊 웃는 · 파랑 · 🌊 바다 · 크레파스 · 「강아지를 안고 있어요」」 */
export function pictureSummary(choices: PictureChoices): string {
  const withEmoji = (group: Group, key: string | undefined): string | null => {
    const option = optionOf(group, key);
    if (!option) return null;
    return option.emoji ? `${option.emoji} ${option.label}` : option.label;
  };
  return [
    withEmoji("gender", choices.gender),
    optionOf("hair", choices.hair)?.label ?? null,
    choices.glasses === "yes" ? "안경" : null,
    withEmoji("expression", choices.expression),
    optionOf("color", choices.color)?.label ?? null,
    withEmoji("background", choices.background),
    optionOf("style", choices.style)?.label ?? null,
    choices.line?.trim() ? `「${choices.line.trim()}」` : null,
  ].filter(Boolean).join(" · ");
}

/**
 * 그림 느낌 예시 그림(D11) — 수업 전에 한 번 만들어 앱에 넣어 둔 정적 파일이다.
 * 학생이 눌러도 AI 를 부르지 않는다(비용·기다림 0).
 */
export function styleSampleUrl(style: NonNullable<PictureChoices["style"]>): string {
  return `/picture-styles/${style}.webp`;
}
